import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/cis')({
  component: RouteComponent,
})

function RouteComponent() {
  return <div>Hello "/cis"!</div>
}
